import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useLocation, NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import Navigation from '../components/Navigation';
import Sidebar from '../components/Sidebar';
import { Modal } from 'react-bootstrap';
import Cookies from 'js-cookie';
import PageLoader from '../components/PageLoader';

// import React, { useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import { useLocation, NavLink } from 'react-router-dom';
// import base_url from '../config/Config';
// import Navigation from '../components/Navigation';
// import Sidebar from '../components/Sidebar';
// import { Modal } from 'react-bootstrap';
// import Cookies from 'js-cookie';


// const ViewLoan = () => {
//     const [loanDetails, setLoanDetails] = useState(null);
//     const [repaymentDetails, setRepaymentDetails] = useState(null);
//     const [error, setError] = useState(null);
//     const [showModalTran, setShowModalTran] = useState(false);
//     const [selectedCollection, setSelectedCollection] = useState(null);
//     const [formData, setFormData] = useState({ companyName: '', loanPaidDate: '' });
//     const [disbursementDate, setDisbursementDate] = useState('');
//     const [permissions, setPermissions] = useState([]);


//     const location = useLocation();
//     const params = new URLSearchParams(location.search);
//     const loanId = params.get('loanId');
//     const customerId = params.get('customerId');
//     const token = Cookies.get('authToken');


//     // collect function 

//     const [showModal, setShowModal] = useState(false);
//     const [selectedEmi, setSelectedEmi] = useState(null);
//     const [paymentAmount, setPaymentAmount] = useState('');
//     const [selectedMode, setSelectedMode] = useState('');
//     const [tranId, setTranId] = useState('');
//     const [selectedService, setSelectedService] = useState('');

//     //    Pemisiion privillages atart 

//       const formatForDateInput = (dateVal) => {
//         if (!dateVal) return '';
//         // If already YYYY-MM-DD
//         if (typeof dateVal === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateVal)) return dateVal;
//         // Try ISO parsing, or fallback to splitting at 'T' if present
//         try {
//             const d = new Date(dateVal);
//             if (!isNaN(d)) {
//                 return d.toISOString().split('T')[0];
//             }
//         } catch (e) {
//             // fallback
//         }
//         if (typeof dateVal === 'string' && dateVal.includes('T')) {
//             return dateVal.split('T')[0];
//         }
//         // last fallback: empty
//         return '';
//     };

//     useEffect(() => {
//         const adminId = localStorage.getItem('adminId') || '';
//         axios.get(`${base_url}/api/auth/tabs/${adminId}`)
//             .then(res => setPermissions(res.data || []))
//             .catch(() => setPermissions([]));
//     }, []);

//     // Permission check helper
//     const hasPermission = useCallback((tabName, action) => {
//         const tab = permissions.find(t => t.tabName === tabName);
//         if (!tab) return false;
//         switch (action) {
//             case 'view': return !!tab.canView;
//             case 'edit': return !!tab.canEdit;
//             case 'download': return !!tab.canDelete; // using canDelete for download
//             default: return false;
//         }
//     }, [permissions]);

//     // Fetch loan details
//     useEffect(() => {
//         const fetchLoanDetails = async () => {
//             if (!hasPermission('Loan', 'view')) return;
//             if (!loanId || !customerId || !token) return;
//             try {
//                 const response = await axios.get(
//                     `${base_url}/api/loan/viewLoan`,
//                     {
//                         params: { customerId, loanId },
//                         headers: {
//                             'Content-Type': 'application/json',
//                             'Authorization': `Bearer ${token}`,
//                         },
//                     }
//                 );
//                 setLoanDetails(response.data);
//             } catch (err) {
//                 setError('Failed to fetch loan details');
//                 console.error("Error fetching loan details:", err);
//             }
//         };

//         fetchLoanDetails();
//     }, [loanId, customerId, token, hasPermission]);

//  useEffect(() => {
//         if (loanDetails) {
//             const formatted = formatForDateInput(loanDetails.disbursementDate || loanDetails.disbursedDate);
//             if (formatted) setDisbursementDate(formatted);
//         }
//     }, [loanDetails]);
    
//     // Fetch repayment details
//     useEffect(() => {
//         const fetchRepaymentDetails = async () => {
//             if (!loanId || !token) return;

//             try {
//                 const response = await axios.get(
//                     `${base_url}/api/repayment/listByLoanId`,
//                     {
//                         params: { loanId },
//                         headers: {
//                             'Content-Type': 'application/json',
//                             'Authorization': `Bearer ${token}`,
//                         },
//                     }
//                 );
//                 setRepaymentDetails(response.data);
//             } catch (err) {
//                 setError('Failed to fetch repayment details');
//                 console.error("Error fetching repayment details:", err);
//             }
//         };

//         fetchRepaymentDetails();
//     }, [loanId, token]);

//     // Open modal
//     const handleModalOpen = (collection) => {
//         if (!collection?.customerId || !collection?.partnerLoanId) {
//             console.error('Invalid collection data:', collection);
//             alert('Invalid collection data. Please check the details.');
//             return;
//         }

//         setSelectedCollection(collection);
//         setFormData({ companyName: '', loanPaidDate: '' });
//         setShowModalTran(true);
//     };

//     // Handle modal form submission
//     const handleModalSubmit = async (e) => {
//         e.preventDefault();
//         if (!selectedCollection || !loanDetails || !token) return;

//         try {
//             const response = await axios.put(
//                 `${base_url}/api/loan/viewLoan`,
//                 formData,
//                 {
//                     params: { customerId, loanId },
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${token}`,
//                     },
//                 }
//             );
//             console.log('Response from API:', response.data);
//             alert('Loan Paid updated successfully.');
//             setShowModalTran(false);
//             setFormData({ companyName: '', loanPaidDate: '' });
//         } catch (error) {
//             console.error('Error updating Loan Paid:', error);
//             alert('Failed to update Loan Paid.');
//         }
//     };


//     // Handle loading or error states
//     if (error) return <div>{error}</div>;
//     if (!loanDetails) return <div>Loading...</div>;

//     const handleApproveLoan = async () => {
//         if (!loanDetails || !loanId || !token) {
//             alert('Missing loan details or token');
//             return;
//         }

//         if (!disbursementDate) {
//             alert('Please select a disbursement date.');
//             return;
//         }

//         // Format date as DD-MM-YYYY
//         const [year, month, day] = disbursementDate.split('-');
//         const formattedDisbursementDate = `${day}-${month}-${year}`;

//         const payload = {
//             productName: loanDetails.productName || "PersonalLoan10K",
//             interestRate: Number(loanDetails.roi),  // exact decimal (e.g., 33.33)
//             interestRateType: Number(loanDetails.roiType),
//             processFee: 1.69,      // fixed value
//             otherDeduction: 5.5,   // fixed value
//             // processFee: Number(loanDetails.processingFee),   
//             // otherDeduction: Number(loanDetails.otherDeduction),
//             loanAmount: Math.round(Number(loanDetails.loanAmount)),
//             tenureInDays: Math.round(Number(loanDetails.tenure)),
//             repaymentType: Number(loanDetails.repaymentType),
//             numberOfEmi: Number(loanDetails.numberOfEmi),
//             productType: parseInt(loanDetails.loanType || 1),
//             disbursementDate: formattedDisbursementDate,
//         };

//         try {
//             const response = await axios.post(
//                 `${base_url}/api/productLogic/approveLoan`,
//                 payload,
//                 {
//                     params: { loanId },
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${token}`,
//                     },
//                 }
//             );

//             alert("Loan approved and EMI generated successfully!");
//             console.log('Approve Loan API response:', response.data);
//         } catch (error) {
//             console.error('Error approving loan:', error);
//             alert('Failed to approve loan.');
//         }
//     };


//     // collect modal open 
//     const handleCollectModalOpen = (emi) => {
//         setSelectedEmi(emi);
//         setShowModal(true);
//         setPaymentAmount(emi.emiAmount || '');
//         setSelectedMode('');
//         setTranId('');
//         setSelectedService('');
//     };

//     const handleSubmitPayment = async () => {
//         if (!selectedEmi || !loanDetails || !customerId) {
//             alert("Missing required data.");
//             return;
//         }

//         //      const modeUpper = selectedMode.toUpperCase();
//         // if (modeUpper !== 'UPI') {
//         //         if (!tranId.trim()) {
//         //             alert("Transaction ID is required for this payment mode.");
//         //             return;
//         //         }
//         //         if (!selectedService.trim()) {
//         //             alert("Service is required for this payment mode.");
//         //             return;
//         //         }
//         //     }
//         const payload = {
//             loanId: loanDetails.id,
//             customerId: loanDetails.customerId,
//             emiId: selectedEmi.id,
//             tranAmount: Number(paymentAmount),
//             tranType: selectedMode === 'CASH' ? 0 : 1,
//             tranId: tranId || '0',
//             service: selectedService || '0',
//             mode: selectedMode.toUpperCase(),
//             isFullPayment: true
//         };

//         try {
//             const response = await axios.post(
//                 `${base_url}/api/payment/collect`,
//                 payload,
//                 {
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${token}`,
//                     },
//                 }
//             );

//             const updatedEmi = response.data;
//             alert(`Payment collected successfully! Updated Status: ${updatedEmi.emiStatus === 1 ? 'Paid' : 'Partial'}`);

//             // ✅ Update your repaymentDetails list with updated EMI
//             setRepaymentDetails(prev =>
//                 prev.map(item => item.id === updatedEmi.id ? updatedEmi : item)
//             );

//             setShowModal(false);
//         } catch (error) {
//             console.error("Payment failed:", error);
//             alert("Failed to collect payment.");
//         }
//     };

//     if (!hasPermission('Loan', 'view')) {
//         return (
//             <div className="text-center mt-5">
//                 <h3>Access Denied</h3>
//                 <p>You do not have permission to view this page.</p>
//             </div>
//         );
//     }

//     return (
//         <>
//             <div className='overviewsaa'>
//                 <h4>Loan View</h4>
//             </div>
//             <div className='navigationss mb-5'>
//                 <Navigation />
//             </div>
//             <div className='container-fluid'>
//                 <div className='row'>
//                     <div className='col-lg-2 col-md-2 sidebarnavigartion'>
//                         <div className='lmssidebar'>
//                             <Sidebar />
//                         </div>
//                     </div>
//                     <div className='col-lg-10 col-md-10'>
//                         <div className='dashboardlms mt-5 text-center'>
//                             <div className='row'>
//                                 <div className="col-md-12 col-lg-12">
//                                     <div className="reportsanalyzier mb-3">
//                                         <div className="row">
//                                             <div className="col-lg-2 col-md-2">
//                                                 <div className="credit buttonandly">
//                                                     <NavLink to={`/headerfile/CreditReport?id=${customerId}`}><p>Credit Report</p></NavLink>
//                                                 </div>
//                                             </div>
//                                             <div className="col-lg-2 col-md-2">
//                                                 <div className="analyzier buttonandly">
//                                                     <NavLink to={`/headerfile/LoanAgreement?id=${customerId}`}><p>Loan Agreement</p></NavLink>
//                                                 </div>
//                                             </div>
//                                             <div className="col-lg-2 col-md-2">
//                                                 <div className="digitalfoot buttonandly">
//                                                     <p>Loan Product</p>
//                                                 </div>
//                                             </div>
//                                             <div className="col-lg-2 col-md-2">
//                                                 <div className="devicehistory buttonandly">
//                                                     <NavLink to={`/operation/ViewVerifiedCustomer?id=${customerId}`}><p>Customer View</p></NavLink>
//                                                 </div>
                                                
//                                             </div>
//                                             <div className="col-lg-2 col-md-2">
//                                                 <div className="location buttonandly">
//                                                     <NavLink to={`/document/LoanDocuments?customerId=${customerId}`}> <p>Document</p></NavLink>
//                                                 </div>
//                                             </div>
//                                             <div className="col-lg-2 col-md-2">
//                                                 <div className="businessverification buttonandly">
//                                                     <NavLink to={`/headerfile/NOC?id=${customerId}`}><p>NOC</p></NavLink>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <hr />
//                                 <div className='col-md-12 col-lg-12 '>
//                                     <div className='personalhead text-justify'>
//                                     </div>

//                                     <div className='row'>
//                                         <div className='col-md-12'>

//                                             <div className='row'>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="loan_id">Loan Id</label><br />
//                                                         <input type="text" name="loan_id" id="loan_id" value={`US0${loanDetails?.id || ''}`} placeholder='Loan Id' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="customer_id">Customer Id</label><br />
//                                                         <input type="text" name="customer_id" id="customer_id" value={`00${loanDetails?.customerId || ''}`} placeholder='Customer Id' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="approved_date">Approved Date</label><br />
//                                                         <input type="text" name="approved_date" id="approved_date" value={loanDetails?.approvedDate ? new Date(loanDetails.approvedDate).toISOString().split('T')[0] : ''} placeholder='Approved Date' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="utr">UTR</label><br />
//                                                         <input type="text" name="utr" id="utr" value={loanDetails?.utr || ''} placeholder='UTR' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="loan_type"> Loan Type</label><br />
//                                                         <input type="text" name="loan_type" id="loan_type" value={loanDetails?.loanType || ''} placeholder='Loan Type' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="loan_amount"> Loan Amount </label><br />
//                                                         <input type="text" name="loan_amount" id="loan_amount" value={loanDetails?.loanAmount || ''} placeholder='Loan Amount' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="otherDeduction">Other Deduction </label> <br />
//                                                         <input type="text" name="otherDeduction" id="otherDeduction" value={loanDetails?.otherDeduction || ''} placeholder='Other Deduction' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="processing_fees">Processing Fees</label> <br />
//                                                         <input type="text" name="processing_fees" id="processing_fees" value={loanDetails?.processingFee || ''} placeholder='Processing Fees' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="disbursed_amount">Disbursed Amount</label><br />
//                                                         <input type="text" name="disbursed_amount" id="disbursed_amount" value={loanDetails?.disbursedAmount || ''} placeholder='Disbursed Amount' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="tenure">Tenure</label><br />
//                                                         <input type="text" name="tenure" id="tenure" value={`${loanDetails?.tenure || ''} Days`} placeholder='Tenure' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="no_of_emi">No Of EMI</label><br />
//                                                         <input type="text" name="no_of_emi" id="no_of_emi" value={loanDetails?.numberOfEmi || ''} placeholder='No of EMI' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="disbursed_date">Disbursed Date</label><br />
//                                                         <input type="text" name="disbursed_date" id="disbursed_date" value={loanDetails?.disbursedDate ? new Date(loanDetails.disbursedDate).toISOString().split('T')[0] : ''} placeholder='Disbursed Date' readOnly />
//                                                     </div>
//                                                 </div>

//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="roiType">ROI Type</label><br />
//                                                         <input type="text" name="roiType" id="roiType" value={loanDetails?.roiType || ''} placeholder='ROI Type' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="roi">ROI </label><br />
//                                                         <input type="text" name="roi" id="roi" value={loanDetails?.roi || ''} placeholder='ROI ' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="repaymentType">Repayment Type </label><br />
//                                                         <input type="repaymentType" name="repaymentType" id="repaymentType" value={loanDetails?.repaymentType || ''} placeholder='ROI ' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="sgst">SGST</label><br />
//                                                         <input type="sgst" name="sgst" id="sgst" value={loanDetails?.sgst || ''} placeholder='SGST ' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="cgst">CGST </label><br />
//                                                         <input type="cgst" name="cgst" id="cgst" value={loanDetails?.cgst || ''} placeholder='CGST ' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="collection_date">Collection Date</label><br />
//                                                         <input type="text" name="collection_date" id="collection_date" value={loanDetails?.collectionDate ? new Date(loanDetails.collectionDate).toISOString().split('T')[0] : ''} placeholder='Collection Date' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="createDate">Create Date</label> <br />
//                                                         <input type="text" name="createDate" id="createDate" value={loanDetails?.createDate ? new Date(loanDetails.createDate).toISOString().split('T')[0] : ''} placeholder='Create Date' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="updateDate">Update Date</label> <br />
//                                                         <input type="text" name="updateDate" id="updateDate" value={loanDetails?.updateDate ? new Date(loanDetails.updateDate).toISOString().split('T')[0] : ''} placeholder='Create Date' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="close_date">Last Paid Date</label><br />
//                                                         <input type="text" name="close_date" id="close_date" value={loanDetails?.loanPaidDate ? new Date(loanDetails.loanPaidDate).toISOString().split('T')[0] : ''} placeholder='Loan Paid Date' readOnly />
//                                                     </div>
//                                                 </div>
//                                                 {/* <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="disbursementDate">Disbursement Date</label><br />
//                                                         <input
//                                                             type="date"  // ✅ Fix here
//                                                             id="disbursementDate"
//                                                             value={disbursementDate}
//                                                             onChange={(e) => setDisbursementDate(e.target.value)}
//                                                             readOnly={!hasPermission('Loan', 'edit')}
//                                                             className={!hasPermission('Loan', 'edit') ? 'readonly-field' : ''}
//                                                         />
//                                                     </div>
//                                                 </div> */}
//                                                  {/* Disbursement date (this is the field you wanted auto-filled) */}
//                                                 <div className='col-md-3 col-lg-3'>
//                                                     <div className='personaldetails text-justify mt-3'>
//                                                         <label htmlFor="disbursementDate">Disbursement Date</label><br />
//                                                         <input
//                                                             type="date"
//                                                             id="disbursementDate"
//                                                             value={disbursementDate}
//                                                             onChange={(e) => setDisbursementDate(e.target.value)}
//                                                             readOnly={!hasPermission('Loan', 'edit')}
//                                                             className={!hasPermission('Loan', 'edit') ? 'readonly-field' : ''}
//                                                         />
//                                                     </div>
//                                                 </div>
//                                                 <div className='col-md-3 col-lg-3  mt-3 '>
//                                                     <div className='personaldetails disbursmentb text-center mt-3'>
//                                                         {hasPermission('Loan', 'edit') && (
//                                                             <button className="btn btn-success mt-3" onClick={handleApproveLoan}>
//                                                                 Approve Loan
//                                                             </button>
//                                                         )}
//                                                     </div>
//                                                 </div>

//                                                 <div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                 </div>
//                             </div>
//                             <div className='row'>
//                                 <div className='col-md-12 col-12 mt-4'>
//                                     <div className='repayment'>
//                                         <h3>Repayment Schedule</h3>
//                                     </div>
//                                 </div>
//                                 <div className='col-md-12 mb-4 mt-2'>
//                                     <div className='table-responsive'>
//                                         <table className='allcustomer table-striped table-hover table table-bordered'>
//                                             <thead>
//                                                 <tr>
//                                                     <th>S_No</th>
//                                                     <th>Loan_Id</th>
//                                                     <th>Customer_Id</th>
//                                                     <th>EMI_Number</th>
//                                                     <th>EMI_Amount</th>
//                                                     <th>Principal</th>
//                                                     <th>Interest</th>
//                                                     <th>Create_Date</th>
//                                                     <th>Due_Date</th>
//                                                     <th>Status</th>
//                                                     <th>Action</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {repaymentDetails && repaymentDetails.length > 0 ? (
//                                                     repaymentDetails.map((item, index) => (
//                                                         <tr key={item.id}>
//                                                             <td>{index + 1}</td>
//                                                             <td>{item.loanId}</td>
//                                                             <td>{item.customerId}</td>
//                                                             <td>{item.emiNumber}</td>
//                                                             <td>{item.emiAmount}</td>
//                                                             <td>{item.principal}</td>
//                                                             <td>{item.interest}</td>
//                                                             <td>{new Date(item.createDate).toLocaleDateString('en-GB')}</td>
//                                                             <td>{new Date(item.dueDate).toLocaleDateString('en-GB')}</td>
//                                                             <td>{item.emiStatus === 0 ? 'Pending' : 'Paid'}</td>
//                                                             <td className='creditcheck'>
//                                                                 {item.emiStatus === 0 && (
//                                                                     <button
//                                                                         onClick={() => handleCollectModalOpen(item)}
//                                                                         className='btn btn-primary btn-sm'
//                                                                     >
//                                                                         Collect_Now
//                                                                     </button>
//                                                                 )}
//                                                             </td>

//                                                         </tr>
//                                                     ))
//                                                 ) : (
//                                                     <tr>
//                                                         <td colSpan="11" className="text-center">
//                                                             No repayment data available
//                                                         </td>
//                                                     </tr>
//                                                 )}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <Modal
//                 show={showModalTran}
//                 onHide={() => setShowModalTran(false)}
//                 backdrop="static"
//                 keyboard={false}
//             >
//                 <Modal.Header>
//                     <Modal.Title>Loan Paid Date</Modal.Title>
//                     <button
//                         type="button"
//                         className="btn-close"
//                         aria-label="Close"
//                         onClick={() => setShowModalTran(false)}
//                     >
//                         ×
//                     </button>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <form onSubmit={handleModalSubmit}>
//                         <div className="">
//                             <label>Company Name</label>
//                             <input
//                                 type="text"
//                                 id="companyName"
//                                 name="companyName"
//                                 className="form-control"
//                                 value={formData.companyName}
//                                 onChange={(e) =>
//                                     setFormData((prev) => ({ ...prev, companyName: e.target.value }))
//                                 }
//                                 required
//                             />
//                         </div>
//                         <div className="">
//                             <label>Loan Paid Date</label>
//                             <input
//                                 type="date"
//                                 id="loanPaidDate"
//                                 name="loanPaidDate"
//                                 className="form-control"
//                                 value={formData.loanPaidDate}
//                                 onChange={(e) =>
//                                     setFormData((prev) => ({
//                                         ...prev,
//                                         loanPaidDate: e.target.value,
//                                     }))
//                                 }
//                                 required
//                             />
//                         </div>
//                         <div className="text-center utrupdatebutton">
//                             <button type="submit" className="btn btn-primary">
//                                 Update
//                             </button>
//                         </div>
//                     </form>
//                 </Modal.Body>
//                 <Modal.Footer></Modal.Footer>
//             </Modal>
//             {showModal && selectedEmi && (
//                 <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
//                     <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '400px' }}>
//                         <div className="modal-content rounded-4 shadow">
//                             <div className="modal-header text-center" style={{ borderBottom: 'none' }}>
//                                 <h5 className="modal-title" style={{ fontSize: '18px', fontWeight: '600' }}>
//                                     Pay EMI #{selectedEmi.emiNumber}
//                                 </h5>
//                             </div>
//                             <div className="modal-body repayments">
//                                 <div className="mb-3">
//                                     <label className="form-label">EMI Amount</label>
//                                     <input
//                                         type="number"
//                                         className="form-control"
//                                         value={paymentAmount}
//                                         onChange={(e) => setPaymentAmount(e.target.value)}
//                                     />
//                                 </div>

//                                 <div className="mb-3">
//                                     <label className="form-label">Mode</label>
//                                     <select
//                                         className="form-select"
//                                         value={selectedMode}
//                                         onChange={(e) => setSelectedMode(e.target.value)}
//                                     >
//                                         <option value="">-- Select Mode --</option>
//                                         <option value="cash">Cash</option>
//                                         <option value="upi">UPI</option>
//                                         <option value="bank">Bank Transfer</option>
//                                     </select>
//                                 </div>

//                                 {selectedMode === 'upi' && (
//                                     <>
//                                         <div className="mb-3">
//                                             <label className="form-label">Transaction ID</label>
//                                             <input
//                                                 type="text"
//                                                 className="form-control"
//                                                 value={tranId}
//                                                 onChange={(e) => setTranId(e.target.value)}
//                                             />
//                                         </div>
//                                         <div className="mb-3">
//                                             <label className="form-label">Service</label>
//                                             <select
//                                                 className="form-select"
//                                                 value={selectedService}
//                                                 onChange={(e) => setSelectedService(e.target.value)}
//                                             >
//                                                 <option value="">-- Select Service --</option>
//                                                 <option value="PhonePe">PhonePe</option>
//                                                 <option value="Google Pay">Google Pay</option>
//                                                 <option value="Paytm">Paytm</option>
//                                                 <option value="BHIM">BHIM</option>
//                                                 <option value="Amazon Pay">Amazon Pay</option>
//                                             </select>
//                                         </div>
//                                     </>
//                                 )}
//                             </div>
//                             <div className="modal-footer d-flex justify-content-between" style={{ borderTop: 'none' }}>
//                                 <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
//                                     Cancel
//                                 </button>
//                                 <div className='loginbutton'>
//                                     <button className="btn btn-primary" onClick={handleSubmitPayment}>
//                                         Submit Payment
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//         </>
//     );
// };

// export default ViewLoan;





// ViewLoan.jsx


const ViewLoan = () => {
    const [loanDetails, setLoanDetails] = useState(null);
    const [pageLoading, setPageLoading] = useState(true);
    const [repaymentDetails, setRepaymentDetails] = useState(null);
    const [error, setError] = useState(null);
    const [showModalTran, setShowModalTran] = useState(false);
    const [selectedCollection, setSelectedCollection] = useState(null);
    const [formData, setFormData] = useState({ companyName: '', loanPaidDate: '' });
    const [disbursementDate, setDisbursementDate] = useState('');
    const [permissions, setPermissions] = useState([]);

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const loanId = params.get('loanId');
    const customerId = params.get('customerId');
    const token = Cookies.get('authToken');

    // collect function
    const [showModal, setShowModal] = useState(false);
    const [selectedEmi, setSelectedEmi] = useState(null);
    const [paymentAmount, setPaymentAmount] = useState('');
    const [selectedMode, setSelectedMode] = useState('');
    const [tranId, setTranId] = useState('');
    const [selectedService, setSelectedService] = useState('');

    // ---------- Helper: safe date formatter for <input type="date"> ----------
    const formatForDateInput = (dateVal) => {
        if (!dateVal) return '';
        // If already YYYY-MM-DD
        if (typeof dateVal === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateVal)) return dateVal;
        // Try ISO parsing, or fallback to splitting at 'T' if present
        try {
            const d = new Date(dateVal);
            if (!isNaN(d)) {
                return d.toISOString().split('T')[0];
            }
        } catch (e) {
            // fallback
        }
        if (typeof dateVal === 'string' && dateVal.includes('T')) {
            return dateVal.split('T')[0];
        }
        // last fallback: empty
        return '';
    };

    //    Permission privileges start
    useEffect(() => {
        const adminId = localStorage.getItem('adminId') || '';
        axios.get(`${base_url}/api/auth/tabs/${adminId}`)
            .then(res => setPermissions(res.data || []))
            .catch(() => setPermissions([]));
    }, []);

    // Permission check helper
    const hasPermission = useCallback((tabName, action) => {
        const tab = permissions.find(t => t.tabName === tabName);
        if (!tab) return false;
        switch (action) {
            case 'view': return !!tab.canView;
            case 'edit': return !!tab.canEdit;
            case 'download': return !!tab.canDelete; // using canDelete for download
            default: return false;
        }
    }, [permissions]);

    // Fetch loan details
    useEffect(() => {
        const fetchLoanDetails = async () => {
            if (!hasPermission('Loan', 'view')) return;
            if (!loanId || !customerId || !token) return;
            try {
                const response = await axios.get(
                    `${base_url}/api/loan/viewLoan`,
                    {
                        params: { customerId, loanId },
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                    }
                );
                setLoanDetails(response.data);
            } catch (err) {
                setError('Failed to fetch loan details');
                console.error("Error fetching loan details:", err);
            }
        };

        fetchLoanDetails();
    }, [loanId, customerId, token, hasPermission]);

    // When loanDetails loads, set disbursementDate (so it's visible in date input)
    useEffect(() => {
        if (loanDetails) {
            const formatted = formatForDateInput(loanDetails.disbursementDate || loanDetails.disbursedDate);
            if (formatted) setDisbursementDate(formatted);
        }
    }, [loanDetails]);

    // Fetch repayment details
    useEffect(() => {
        const fetchRepaymentDetails = async () => {
            if (!loanId || !token) return;

            try {
                const response = await axios.get(
                    `${base_url}/api/repayment/listByLoanId`,
                    {
                        params: { loanId },
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                    }
                );
                setRepaymentDetails(response.data);
            } catch (err) {
                setError('Failed to fetch repayment details');
                console.error("Error fetching repayment details:", err);
            } finally {
                setPageLoading(false);
            }
        };

        fetchRepaymentDetails();
    }, [loanId, token]);

    // Open modal
    // eslint-disable-next-line no-unused-vars
    const handleModalOpen = (collection) => {
        if (!collection?.customerId || !collection?.partnerLoanId) {
            console.error('Invalid collection data:', collection);
            alert('Invalid collection data. Please check the details.');
            return;
        }

        setSelectedCollection(collection);
        setFormData({ companyName: '', loanPaidDate: '' });
        setShowModalTran(true);
    };

    // Handle modal form submission
    const handleModalSubmit = async (e) => {
        e.preventDefault();
        if (!selectedCollection || !loanDetails || !token) return;

        try {
            const response = await axios.put(
                `${base_url}/api/loan/viewLoan`,
                formData,
                {
                    params: { customerId, loanId },
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );
            console.log('Response from API:', response.data);
            alert('Loan Paid updated successfully.');
            setShowModalTran(false);
            setFormData({ companyName: '', loanPaidDate: '' });
        } catch (error) {
            console.error('Error updating Loan Paid:', error);
            alert('Failed to update Loan Paid.');
        }
    };

    // Handle loading or error states
    if (error) return <div>{error}</div>;
    if (!loanDetails) return <div>Loading...</div>;

    const handleApproveLoan = async () => {
        if (!loanDetails || !loanId || !token) {
            alert('Missing loan details or token');
            return;
        }

        if (!disbursementDate) {
            alert('Please select a disbursement date.');
            return;
        }

        // Format date as DD-MM-YYYY
        const [year, month, day] = disbursementDate.split('-');
        const formattedDisbursementDate = `${day}-${month}-${year}`;

        const payload = {
            productName: loanDetails.productName || "PersonalLoan10K",
            interestRate: Number(loanDetails.roi),  // exact decimal (e.g., 33.33)
            interestRateType: Number(loanDetails.roiType),
            processFee: 1.69,      // fixed value
            otherDeduction: 6.5,   // fixed value
            loanAmount: Math.round(Number(loanDetails.loanAmount)),
            tenureInDays: Math.round(Number(loanDetails.tenure)),
            repaymentType: Number(loanDetails.repaymentType),
            numberOfEmi: Number(loanDetails.numberOfEmi),
            productType: parseInt(loanDetails.loanType || 1),
            disbursementDate: formattedDisbursementDate,
        };

        try {
            const response = await axios.post(
                `${base_url}/api/productLogic/approveLoan`,
                payload,
                {
                    params: { loanId },
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            alert("Loan approved and EMI generated successfully!");
            console.log('Approve Loan API response:', response.data);

            // Optionally update loanDetails.disbursementDate locally if API doesn't return full updated loan
            // setLoanDetails(prev => prev ? { ...prev, disbursementDate: disbursementDate } : prev);
        } catch (error) {
            console.error('Error approving loan:', error);
            alert('Failed to approve loan.');
        }
    };

    // collect modal open
    const handleCollectModalOpen = (emi) => {
        setSelectedEmi(emi);
        setShowModal(true);
        setPaymentAmount(emi.emiAmount || '');
        setSelectedMode('');
        setTranId('');
        setSelectedService('');
    };

    // const handleSubmitPayment = async () => {
    //     if (!selectedEmi || !loanDetails || !customerId) {
    //         alert("Missing required data.");
    //         return;
    //     }

    //     const payload = {
    //         loanId: loanDetails.id,
    //         customerId: loanDetails.customerId,
    //         emiId: selectedEmi.id,
    //         tranAmount: Number(paymentAmount),
    //         tranType: selectedMode === 'CASH' ? 0 : 1,
    //         tranId: tranId || '0',
    //         service: selectedService || '0',
    //         mode: selectedMode.toUpperCase(),
    //         isFullPayment: true
    //     };

    //     try {
    //         const response = await axios.post(
    //             `${base_url}/api/payment/collect`,
    //             payload,
    //             {
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     'Authorization': `Bearer ${token}`,
    //                 },
    //             }
    //         );

    //         const updatedEmi = response.data;
    //         alert(`Payment collected successfully! Updated Status: ${updatedEmi.emiStatus === 1 ? 'Paid' : 'Partial'}`);

    //         // ✅ Update your repaymentDetails list with updated EMI (handle null prev)
    //         setRepaymentDetails(prev =>
    //             Array.isArray(prev) ? prev.map(item => item.id === updatedEmi.id ? updatedEmi : item) : prev
    //         );

    //         setShowModal(false);
    //     } catch (error) {
    //         console.error("Payment failed:", error);
    //         alert("Failed to collect payment.");
    //     }
    // };

    const handleSubmitPayment = async () => {
        if (!selectedEmi || !loanDetails || !customerId) {
            alert("Missing required data.");
            return;
        }

        const payAmount = Number(paymentAmount);
        const remainingEmi = Number(selectedEmi.emiAmount);

        if (!payAmount || payAmount <= 0) {
            alert("Please enter valid payment amount");
            return;
        }

        if (payAmount > remainingEmi) {
            alert("Payment amount cannot be greater than remaining EMI");
            return;
        }

        const payload = {
            loanId: loanDetails.id,
            customerId: loanDetails.customerId,
            emiId: selectedEmi.id,
            tranAmount: payAmount,
            tranType: selectedMode === 'cash' ? 0 : 1,
            tranId: tranId || null,
            service: selectedService || null,
            mode: selectedMode.toUpperCase()
        };

        try {
            const response = await axios.post(
                `${base_url}/api/payment/collect`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            const updatedEmi = response.data;

            alert(
                updatedEmi.emiStatus === 1
                    ? "EMI fully paid ✅"
                    : "Partial payment successful ✅"
            );

            // ✅ Update EMI list
            setRepaymentDetails(prev =>
                Array.isArray(prev)
                    ? prev.map(item =>
                        item.id === selectedEmi.id
                            ? { ...item, ...updatedEmi }
                            : item
                    )
                    : prev
            );

            setShowModal(false);
            setPaymentAmount('');
            setTranId('');
            setSelectedService('');

        } catch (error) {
            console.error("Payment failed:", error);
            alert(
                error?.response?.data?.message ||
                "Failed to collect payment"
            );
        }
    };




    const handleRevert = async (emiId) => {
        const confirmed = window.confirm("⚠️ Are you sure you want to revert this payment?");
        if (!confirmed) return;

        try {
            const response = await axios.post(
                `${base_url}/api/payment/revert`,
                { emiId },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            alert(response.data.message || "Payment reverted successfully ✅");
            // Optionally refresh repayment details after revert:
            // re-fetch list or update local state
        } catch (error) {
            console.error("Revert failed:", error);
            alert("❌ Failed to revert payment. Please try again.");
        }
    };

    const handleDueDateChange = async (item, newDate) => {
        if (!newDate) return;

        const confirmShift = window.confirm(
            `Are you sure you want to shift EMI #${item.emiNumber} due date to ${newDate}?`
        );
        if (!confirmShift) return;

        try {
            const response = await axios.post(
                `${base_url}/api/payment/shiftDate`,
                {
                    emiId: item.id,
                    newDueDate: newDate,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            alert(response.data.message || "✅ EMI due date shifted successfully");
            // Optionally update repaymentDetails locally or re-fetch
        } catch (error) {
            alert(
                "❌ Failed to shift EMI date: " +
                (error.response?.data?.message || error.message)
            );
        }
    };

    if (!hasPermission('Loan', 'view')) {
        return (
            <div className="text-center mt-5">
                <h3>Access Denied</h3>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }

    if (pageLoading) return <PageLoader text="Loading Loan Details..." />;

    return (
        <>
            <div className='overviewsaa'>
                <h4>Loan View</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <div className="col-md-12 col-lg-12">
                                    <div className="reportsanalyzier mb-3">
                                        <div className="row">
                                            <div className="col-lg-2 col-md-2">
                                                <div className="credit buttonandly">
                                                    <NavLink to={`/headerfile/CreditReport?id=${customerId}`}><p>Credit Report</p></NavLink>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2">
                                                <div className="analyzier buttonandly">
                                                    <NavLink to={`/headerfile/LoanAgreement?id=${customerId}`}><p>Loan Agreement</p></NavLink>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2">
                                                <div className="digitalfoot buttonandly">
                                                    <p>Loan Product</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2">
                                                <div className="devicehistory buttonandly">
                                                    <NavLink to={`/operation/ViewVerifiedCustomer?id=${customerId}`}><p>Customer View</p></NavLink>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2">
                                                <div className="location buttonandly">
                                                    <NavLink to={`/document/LoanDocuments?customerId=${customerId}`}> <p>Document</p></NavLink>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2">
                                                <div className="businessverification buttonandly">
                                                    <NavLink to={`/headerfile/NOC?id=${customerId}`}><p>NOC</p></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify'>
                                    </div>

                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='row'>
                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="loan_id">Loan Id</label><br />
                                                        <input type="text" name="loan_id" id="loan_id" value={`JU0${loanDetails?.id || ''}`} placeholder='Loan Id' readOnly />
                                                    </div>
                                                </div>
                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="customer_id">Customer Id</label><br />
                                                        <input type="text" name="customer_id" id="customer_id" value={`00${loanDetails?.customerId || ''}`} placeholder='Customer Id' readOnly />
                                                    </div>
                                                </div>
                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="approved_date">Approved Date</label><br />
                                                        <input type="text" name="approved_date" id="approved_date" value={loanDetails?.approvedDate ? formatForDateInput(loanDetails.approvedDate) : ''} placeholder='Approved Date' readOnly />
                                                    </div>
                                                </div>
                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="utr">UTR</label><br />
                                                        <input type="text" name="utr" id="utr" value={loanDetails?.utr || ''} placeholder='UTR' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="loan_type"> Loan Type</label><br />
                                                        <input type="text" name="loan_type" id="loan_type" value={loanDetails?.loanType || ''} placeholder='Loan Type' readOnly />
                                                    </div>
                                                </div>
                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="loan_amount"> Loan Amount </label><br />
                                                        <input type="text" name="loan_amount" id="loan_amount" value={loanDetails?.loanAmount || ''} placeholder='Loan Amount' readOnly />
                                                    </div>
                                                </div>
                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="otherDeduction">Other Deduction </label> <br />
                                                        <input type="text" name="otherDeduction" id="otherDeduction" value={loanDetails?.otherDeduction || ''} placeholder='Other Deduction' readOnly />
                                                    </div>
                                                </div>
                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="processing_fees">Processing Fees</label> <br />
                                                        <input type="text" name="processing_fees" id="processing_fees" value={loanDetails?.processingFee || ''} placeholder='Processing Fees' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="disbursed_amount">Disbursed Amount</label><br />
                                                        <input type="text" name="disbursed_amount" id="disbursed_amount" value={loanDetails?.disbursedAmount || ''} placeholder='Disbursed Amount' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="tenure">Tenure</label><br />
                                                        <input type="text" name="tenure" id="tenure" value={`${loanDetails?.tenure || ''} Days`} placeholder='Tenure' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="no_of_emi">No Of EMI</label><br />
                                                        <input type="text" name="no_of_emi" id="no_of_emi" value={loanDetails?.numberOfEmi || ''} placeholder='No of EMI' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="disbursed_date">Disbursed Date</label><br />
                                                        <input type="text" name="disbursed_date" id="disbursed_date" value={loanDetails?.disbursedDate ? formatForDateInput(loanDetails.disbursedDate) : ''} placeholder='Disbursed Date' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="roiType">ROI Type</label><br />
                                                        <input type="text" name="roiType" id="roiType" value={loanDetails?.roiType || ''} placeholder='ROI Type' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="roi">ROI </label><br />
                                                        <input type="text" name="roi" id="roi" value={loanDetails?.roi || ''} placeholder='ROI ' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="repaymentType">Repayment Type </label><br />
                                                        <input type="text" name="repaymentType" id="repaymentType" value={loanDetails?.repaymentType || ''} placeholder='Repayment Type' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="sgst">SGST</label><br />
                                                        <input type="text" name="sgst" id="sgst" value={loanDetails?.sgst || ''} placeholder='SGST ' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="cgst">CGST </label><br />
                                                        <input type="text" name="cgst" id="cgst" value={loanDetails?.cgst || ''} placeholder='CGST ' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="collection_date">Collection Date</label><br />
                                                        <input type="text" name="collection_date" id="collection_date" value={loanDetails?.collectionDate ? formatForDateInput(loanDetails.collectionDate) : ''} placeholder='Collection Date' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="createDate">Create Date</label> <br />
                                                        <input type="text" name="createDate" id="createDate" value={loanDetails?.createDate ? formatForDateInput(loanDetails.createDate) : ''} placeholder='Create Date' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="updateDate">Update Date</label> <br />
                                                        <input type="text" name="updateDate" id="updateDate" value={loanDetails?.updateDate ? formatForDateInput(loanDetails.updateDate) : ''} placeholder='Update Date' readOnly />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="close_date">Last Paid Date</label><br />
                                                        <input type="text" name="close_date" id="close_date" value={loanDetails?.loanPaidDate ? formatForDateInput(loanDetails.loanPaidDate) : ''} placeholder='Loan Paid Date' readOnly />
                                                    </div>
                                                </div>

                                                {/* Disbursement date (this is the field you wanted auto-filled) */}
                                                <div className='col-md-3 col-lg-3'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="disbursementDate">Disbursement Date</label><br />
                                                        <input
                                                            type="date"
                                                            id="disbursementDate"
                                                            value={disbursementDate}
                                                            onChange={(e) => setDisbursementDate(e.target.value)}
                                                            readOnly={!hasPermission('Loan', 'edit')}
                                                            className={!hasPermission('Loan', 'edit') ? 'readonly-field' : ''}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='col-md-3 col-lg-3  mt-3 '>
                                                    <div className='personaldetails disbursmentb text-center mt-3'>
                                                        {hasPermission('Loan', 'edit') && (
                                                            <button className="btn btn-success mt-3" onClick={handleApproveLoan}>
                                                                Approve Loan
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>

                                                <div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* Repayment table */}
                            <div className='row'>
                                <div className='col-md-12 col-12 mt-4'>
                                    <div className='repayment'>
                                        <h3>Repayment Schedule</h3>
                                    </div>
                                </div>
                                <div className='col-md-12 mb-4 mt-2'>
                                    <div className='table-responsive'>
                                        <table className='allcustomer table-striped table-hover table table-bordered'>
                                            <thead>
                                                <tr>
                                                    <th>S_No</th>
                                                    <th>Loan_Id</th>
                                                    <th>Customer_Id</th>
                                                    <th>EMI_Number</th>
                                                    <th>EMI_Amount</th>
                                                    <th>Principal</th>
                                                    <th>Interest</th>
                                                    <th>Create_Date</th>
                                                    <th>Due_Date</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {repaymentDetails && repaymentDetails.length > 0 ? (
                                                    [...repaymentDetails]
                                                        .sort((a, b) => a.emiNumber - b.emiNumber)
                                                        .map((item, index) => (
                                                            <tr key={item.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.loanId}</td>
                                                                <td>{item.customerId}</td>
                                                                <td>{item.emiNumber}</td>
                                                                <td>{item.emiAmount}</td>
                                                                <td>{item.principal}</td>
                                                                <td>{item.interest}</td>
                                                                <td>{item.createDate ? new Date(item.createDate).toLocaleDateString('en-GB') : ''}</td>

                                                                <td>
                                                                    {item.emiStatus === 0 ? (
                                                                        <input
                                                                            type="date"
                                                                            className="form-control form-control-sm"
                                                                            defaultValue={formatForDateInput(item.dueDate)}
                                                                            onChange={(e) => handleDueDateChange(item, e.target.value)}
                                                                            style={{ width: '150px' }}
                                                                        />
                                                                    ) : (
                                                                        item.dueDate ? new Date(item.dueDate).toLocaleDateString('en-GB') : ''
                                                                    )}
                                                                </td>

                                                                <td>{item.emiStatus === 0 ? 'Pending' : 'Paid'}</td>

                                                                {/* <td className="creditcheck">
                                                                    {item.emiStatus === 0 && (
                                                                        <button
                                                                            onClick={() => handleCollectModalOpen(item)}
                                                                            className="btn btn-primary btn-sm"
                                                                        >
                                                                            Collect Now
                                                                        </button>
                                                                    )}
                                                                    {item.emiStatus === 1 && (
                                                                        <button
                                                                            onClick={() => handleRevert(item.id)}
                                                                            className="btn btn-danger btn-sm"
                                                                        >
                                                                            Revert
                                                                        </button>
                                                                    )}
                                                                </td> */}
                                                                <td className="creditcheck">

    {/* UNPAID or PARTIAL → Collect */}
    {(item.emiStatus === 0 || item.emiStatus === 2) && (
        <button
            onClick={() => handleCollectModalOpen(item)}
            className="btn btn-primary btn-sm"
        >
            Collect Now
        </button>
    )}

    {/* FULL PAID → Revert */}
    {item.emiStatus === 1 && (
        <button
            onClick={() => handleRevert(item.id)}
            className="btn btn-danger btn-sm"
        >
            Revert
        </button>
    )}

</td>

                                                            </tr>
                                                        ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="11" className="text-center">
                                                            No repayment data available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Loan Paid modal */}
            <Modal
                show={showModalTran}
                onHide={() => setShowModalTran(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title>Loan Paid Date</Modal.Title>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => setShowModalTran(false)}
                    >
                        ×
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleModalSubmit}>
                        <div className="">
                            <label>Company Name</label>
                            <input
                                type="text"
                                id="companyName"
                                name="companyName"
                                className="form-control"
                                value={formData.companyName}
                                onChange={(e) =>
                                    setFormData((prev) => ({ ...prev, companyName: e.target.value }))
                                }
                                required
                            />
                        </div>
                        <div className="">
                            <label>Loan Paid Date</label>
                            <input
                                type="date"
                                id="loanPaidDate"
                                name="loanPaidDate"
                                className="form-control"
                                value={formData.loanPaidDate}
                                onChange={(e) =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        loanPaidDate: e.target.value,
                                    }))
                                }
                                required
                            />
                        </div>
                        <div className="text-center utrupdatebutton">
                            <button type="submit" className="btn btn-primary">
                                Update
                            </button>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>

            {/* Collect EMI modal (inline) */}
            {showModal && selectedEmi && (
                <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '400px' }}>
                        <div className="modal-content rounded-4 shadow">
                            <div className="modal-header text-center" style={{ borderBottom: 'none' }}>
                                <h5 className="modal-title" style={{ fontSize: '18px', fontWeight: '600' }}>
                                    Pay EMI #{selectedEmi.emiNumber}
                                </h5>
                            </div>
                            <div className="modal-body repayments">
                                {/* <div className="mb-3">
                                    <label className="form-label">EMI Amount</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={paymentAmount}
                                        onChange={(e) => setPaymentAmount(e.target.value)}
                                    />
                                </div> */}
                                <div className="mb-3">
                                    <label className="form-label">
                                        Pay Amount (Remaining: ₹{selectedEmi.emiAmount})
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={paymentAmount}
                                        max={selectedEmi.emiAmount}
                                        onChange={(e) => setPaymentAmount(e.target.value)}
                                        placeholder={`Max ₹${selectedEmi.emiAmount}`}
                                    />
                                </div>


                                {/* <div className="mb-3">
                                    <label className="form-label">Mode</label>
                                    <select
                                        className="form-select"
                                        value={selectedMode}
                                        onChange={(e) => setSelectedMode(e.target.value)}
                                    >
                                        <option value="">-- Select Mode --</option>
                                        <option value="cash">Cash</option>
                                        <option value="upi">UPI</option>
                                        <option value="bank">Bank Transfer</option>
                                    </select>
                                </div> */}

                                <div className="mb-3">
                                    <label className="form-label">Mode</label>
                                    <select
                                        className="form-select"
                                        value={selectedMode}
                                        onChange={(e) => setSelectedMode(e.target.value)}
                                    >
                                        <option value="">-- Select Mode --</option>
                                        <option value="cash">Cash</option>
                                        <option value="upi">UPI</option>
                                        <option value="bank">Bank Transfer</option>
                                    </select>
                                </div>


                                {selectedMode === 'upi' && (
                                    <>
                                        <div className="mb-3">
                                            <label className="form-label">Transaction ID</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={tranId}
                                                onChange={(e) => setTranId(e.target.value)}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Service</label>
                                            <select
                                                className="form-select"
                                                value={selectedService}
                                                onChange={(e) => setSelectedService(e.target.value)}
                                            >
                                                <option value="">-- Select Service --</option>
                                                <option value="PhonePe">PhonePe</option>
                                                <option value="Google Pay">Google Pay</option>
                                                <option value="Paytm">Paytm</option>
                                                <option value="BHIM">BHIM</option>
                                                <option value="Amazon Pay">Amazon Pay</option>
                                            </select>
                                        </div>
                                    </>
                                )}

                            </div>
                            <div className="modal-footer d-flex justify-content-between" style={{ borderTop: 'none' }}>
                                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                    Cancel
                                </button>
                                <div className='loginbutton'>
                                    <button className="btn btn-primary" onClick={handleSubmitPayment}>
                                        Submit Payment
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ViewLoan;
